import React from 'react';

import { useStyles } from './styles';

export const Box = ({
  children,
  padding,
  classes = {}
}: BoxProps) => {
  const innerClasses = useStyles({ padding });
  return (
    <div
      className={`${innerClasses.container} ${classes.root}`}
    >
      {children}
    </div>
  );
};

type Padding = {
  [key in 'top' | 'right' | 'bottom' | 'left']?: number;
}

interface Classes {
  root?: string;
}

export interface BoxProps {
  padding?: Padding | number;
  children: React.ReactNode;
  classes?: Classes;
}
